import {ReactNode} from 'react'

type Props = {
  children: ReactNode
}

export const ErrorMessage = ({children}: Props) => {
  return <div className="text-brand-red text-[14px] leading-[140%]">{children}</div>
}
